<template>
  <div ref="videoContainer" class="videoPlayer-container paused" data-volume-level="high" @dblclick="toggleFullScreenMode">
    <img class="thumbnail-img" />
    <!-- <div style="color:teal;position:absolute;top:0;right:0">WATCHED</div> -->
    <div class="central-play-pause-btns" @click="togglePlay">
      <div id="centralPlayPauseBtn" class="central-pause-btn" v-if="!isVideoPlaying"><i class="fas fa-pause"></i></div>
      <div id="centralPlayPauseBtn" class="central-play-btn" v-if="isVideoPlaying"><i class="fas fa-play"></i></div>
    </div>
    <div class="video-controls-container">
      <div ref="timeline" class="timeline-container" @mousemove="handleTimelineUpdate" @mousedown="toggleScrubbing">
        <div class="timeline">
          <!-- <img class="preview-img"> -->
          <div class="thumb-indicator"></div>
        </div>
      </div>
      <div class="controls">
        <button class="play-pause-btn" @click="togglePlay">
          <svg class="play-icon" viewBox="0 0 24 24" v-if="!isVideoPlaying">
            <path fill="currentColor" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
          </svg>
          <svg class="play-icon" viewBox="0 0 24 24" v-if="isVideoPlaying">
            <path fill="currentColor" d="M14,19H18V5H14M6,19H10V5H6V19Z" />
          </svg>
        </button>
        <div class="volume-container">
          <button class="mute-btn" @click="toggleMute">
            <svg class="volume-high-icon" viewBox="0 0 24 24" v-if="volumeLevel == 'high'">
              <path
                fill="currentColor"
                d="M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.84 14,18.7V20.77C18,19.86 21,16.28 21,12C21,7.72 18,4.14 14,3.23M16.5,12C16.5,10.23 15.5,8.71 14,7.97V16C15.5,15.29 16.5,13.76 16.5,12M3,9V15H7L12,20V4L7,9H3Z" />
            </svg>
            <svg class="volume-low-icon" viewBox="0 0 24 24" v-if="volumeLevel == 'low'">
              <path fill="currentColor" d="M5,9V15H9L14,20V4L9,9M18.5,12C18.5,10.23 17.5,8.71 16,7.97V16C17.5,15.29 18.5,13.76 18.5,12Z" />
            </svg>
            <svg class="volume-muted-icon" viewBox="0 0 24 24" v-if="volumeLevel == 'muted'">
              <path
                fill="currentColor"
                d="M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z" />
            </svg>
          </button>
          <input ref="volumeSlider" class="volume-slider" type="range" min="0" max="1" step="any" value="1" @input="onInputVolume" />
        </div>
        <div class="duration-container">
          <div class="current-time">{{ formatDuration(currentTime) }}</div>
          /
          <div class="total-time">{{ formatDuration(totalTime) }}</div>
        </div>
        <button class="captions-btn" v-if="false">
          <svg viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M18,11H16.5V10.5H14.5V13.5H16.5V13H18V14A1,1 0 0,1 17,15H14A1,1 0 0,1 13,14V10A1,1 0 0,1 14,9H17A1,1 0 0,1 18,10M11,11H9.5V10.5H7.5V13.5H9.5V13H11V14A1,1 0 0,1 10,15H7A1,1 0 0,1 6,14V10A1,1 0 0,1 7,9H10A1,1 0 0,1 11,10M19,4H5C3.89,4 3,4.89 3,6V18A2,2 0 0,0 5,20H19A2,2 0 0,0 21,18V6C21,4.89 20.1,4 19,4Z" />
          </svg>
        </button>
        <select class="speed-select" v-model="playbackRate" @change="changePlaybackSpeed">
          <option :value="0.25">0.25x</option>
          <option :value="0.5">0.5x</option>
          <option :value="0.75">0.75x</option>
          <option :value="1">1x</option>
          <option :value="1.25">1.25x</option>
          <option :value="1.5">1.5x</option>
          <option :value="1.75">1.75x</option>
          <option :value="2">2x</option>
        </select>
        <button class="mini-player-btn" @click="toggleMiniPlayerMode">
          <svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z" />
          </svg>
        </button>
        <button class="theater-btn" @click="toggleTheaterMode" v-if="false">
          <svg class="tall" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z" />
          </svg>
          <svg class="wide" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z" />
          </svg>
        </button>
        <button class="full-screen-btn" @click="toggleFullScreenMode">
          <svg class="open" viewBox="0 0 24 24">
            <path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
          </svg>
          <svg class="close" viewBox="0 0 24 24">
            <path fill="currentColor" d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
          </svg>
        </button>
      </div>
    </div>
    <video
      ref="video"
      preload
      playsinline
      oncontextmenu="event.preventDefault();"
      :src="src"
      :poster="product.image"
      @loadeddata="onLoadedData"
      @progress="onBufferProgress"
      @timeupdate="onTimeUpdate"
      @volumechange="onVolumeChange"
      @play="onPlay"
      @pause="onPause"
      @ended="onEnded"
      @click.prevent="videoClicked">
      <track kind="captions" srclang="en" src="assets/subtitles.vtt" />
    </video>
  </div>
</template>

<script>
export default {
  name: 'VideoPlayer',
  props: {
    product: {
      type: Object,
      required: true,
    },
    src: {
      type: String,
      required: true,
    },
    openFullScreenVideo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVideoPlaying: false,
      totalTime: 0,
      currentTime: 0,
      percentPlayed: 0,
      isScrubbing: false,
      wasPaused: false,
      volumeLevel: 'high',
      playbackRate: 1,
      runPlayPauseAnimation: true,
    };
  },
  watch: {
    src() {
      if (this.product.consume?.currentPosition) {
        this.$refs.video.currentTime = this.product.consume.currentPosition;
        this.$refs.video.play().catch(() => {});
      }
    },
  },
  methods: {
    onLoadedData() {
      if (!this.$refs.video) return;
      this.totalTime = this.$refs.video.duration;
      if (this.product.consume?.currentPosition) {
        this.$refs.video.currentTime = this.product.consume.currentPosition;
        this.$refs.video.play().catch(() => {});
      }
    },
    onBufferProgress(e) {
      if (!this.$refs.timeline || !e.target.buffered.length) return;
      const previewPosition = e.target.buffered.end(e.target.buffered.length - 1) / this.totalTime;
      this.$refs.timeline.style.setProperty('--preview-position', previewPosition);
      // console.log('onBufferProgress', previewPosition);
    },
    onTimeUpdate() {
      if (!this.$refs.video) return;
      this.currentTime = this.$refs.video.currentTime;
      this.percentPlayed = this.currentTime / this.totalTime;
      this.$refs.timeline.style.setProperty('--progress-position', this.percentPlayed);
    },
    toggleMute() {
      if (!this.$refs.video) return;
      this.$refs.video.muted = !this.$refs.video.muted;
    },
    onInputVolume(e) {
      if (!this.$refs.video) return;
      this.$refs.video.volume = e.target.value;
      this.$refs.video.muted = e.target.value === 0;
    },
    onVolumeChange() {
      if (!this.$refs.video) return;
      const volumeSlider = this.$refs.volumeSlider;
      const video = this.$refs.video;
      volumeSlider.value = video.volume;
      if (video.muted || video.volume === 0) {
        volumeSlider.value = 0;
        this.volumeLevel = 'muted';
      } else if (video.volume >= 0.5) {
        this.volumeLevel = 'high';
      } else {
        this.volumeLevel = 'low';
      }
    },
    changePlaybackSpeed(e) {
      if (!this.$refs.video) return;
      this.playbackRate = e.target.value;
      this.$refs.video.playbackRate = this.playbackRate;
    },
    handleTimelineUpdate(e) {
      // console.log('handleTimelineUpdate', e);
      const rect = this.$refs.timeline.getBoundingClientRect();
      const previewPosition = Math.min(Math.max(0, e.x - rect.x), rect.width) / rect.width;
      this.$refs.timeline.style.setProperty('--progress-position', previewPosition);
      // const previewImgNumber = Math.max(1, Math.floor((percent * video.duration) / 10));
      // const previewImgSrc = `assets/previewImgs/preview${previewImgNumber}.jpg`;
      // previewImg.src = previewImgSrc;

      if (this.isScrubbing) {
        e.preventDefault();
        // thumbnailImg.src = previewImgSrc;
        this.$refs.timeline.style.setProperty('--progress-position', previewPosition);
      }
    },
    toggleScrubbing(e) {
      // console.log('toggleScrubbing', { e });
      const rect = this.$refs.timeline.getBoundingClientRect();
      const percent = Math.min(Math.max(0, e.x - rect.x), rect.width) / rect.width;
      this.isScrubbing = !this.isScrubbing;
      this.$refs.videoContainer.classList.toggle('scrubbing', this.isScrubbing);
      if (this.isScrubbing) {
        this.wasPaused = this.$refs.video.paused;
        this.$refs.video.pause();
      } else {
        this.$refs.video.currentTime = percent * this.$refs.video.duration;
        if (!this.wasPaused) this.$refs.video.play().catch(() => {});
      }
      this.handleTimelineUpdate(e);
    },
    documentMouseUpHandler(e) {
      if (this.isScrubbing) this.toggleScrubbing(e);
    },
    documentMouseMoveHandler(e) {
      if (this.isScrubbing) this.handleTimelineUpdate(e);
    },
    videoClicked() {
      this.$emit('videoClicked');
      this.isVideoPlaying ? this.$refs.video.pause() : this.$refs.video.play().catch(() => {});
    },
    togglePlay() {
      this.$refs.video.paused ? this.$refs.video.play().catch(() => {}) : this.$refs.video.pause();
    },
    onPlay() {
      if (!this.$refs.videoContainer) return;
      this.isVideoPlaying = true;
      if (this.currentTime) this.$emit('play', { type: 'play', currentPosition: this.currentTime, totalLength: this.totalTime });
      this.$refs.videoContainer.classList.remove('paused');
      setTimeout(() => {
        document.getElementById('centralPlayPauseBtn').classList.add('animatePlayPause');
      }, 100);
    },
    onPause() {
      if (!this.$refs.videoContainer) return;
      this.isVideoPlaying = false;
      if (this.currentTime) this.$emit('pause', { type: 'pause', currentPosition: this.currentTime, totalLength: this.totalTime });
      this.$refs.videoContainer.classList.add('paused');
      setTimeout(() => {
        document.getElementById('centralPlayPauseBtn').classList.add('animatePlayPause');
      }, 100);
    },
    onEnded() {
      // console.log('onEnded');
      this.isVideoPlaying = false;
    },
    leadingZeroFormatter(value) {
      return value < 10 ? `0${value}` : value;
    },
    formatDuration(time) {
      const seconds = Math.floor(time % 60);
      const minutes = Math.floor(time / 60) % 60;
      const hours = Math.floor(time / 3600);
      if (hours === 0) {
        return `${minutes}:${this.leadingZeroFormatter(seconds)}`;
      } else {
        return `${hours}:${this.leadingZeroFormatter(minutes)}:${this.leadingZeroFormatter(seconds)}`;
      }
    },
    toggleMiniPlayerMode() {
      if (this.$refs.videoContainer?.classList.contains('mini-player')) {
        document.exitPictureInPicture();
      } else {
        this.$refs.video.requestPictureInPicture();
      }
    },
    toggleTheaterMode() {
      this.$refs.videoContainer?.classList.toggle('theater');
    },
    toggleFullScreenMode() {
      if (!this.$refs.videoContainer || !this.$refs.video) return;

      try {
        const videoContainer = this.$refs.videoContainer;
        const video = this.$refs.video;

        if (document.fullscreenElement == null) {
          video.style.margin = 'auto';
          if (!videoContainer.requestFullscreen && video.webkitEnterFullScreen) {
            video.webkitEnterFullScreen();
          } else videoContainer.requestFullscreen();
        } else {
          video.style.margin = '0';
          document.exitFullscreen();
        }
      } catch (error) {}
    },
    keyboardHandler(e) {
      const tagName = document.activeElement.tagName.toLowerCase();

      if (tagName === 'input') return;
      const video = this.$refs.video;

      switch (e.key.toLowerCase()) {
        case ' ':
          if (tagName === 'button') return;
        case 'k':
          this.togglePlay();
          break;
        case 'f':
          this.toggleFullScreenMode();
          break;
        case 't':
          this.toggleTheaterMode();
          break;
        case 'i':
          this.toggleMiniPlayerMode();
          break;
        case 'm':
          this.toggleMute();
          break;
        case 'arrowleft':
        case 'j':
          video.currentTime += -5;
          break;
        case 'arrowright':
        case 'l':
          video.currentTime += 5;
          break;
        case 'c':
          // toggleCaptions();
          break;
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', this.keyboardHandler);
    document.addEventListener('mouseup', this.documentMouseUpHandler);
    document.addEventListener('mousemove', this.documentMouseMoveHandler);
    if (this.openFullScreenVideo) {
      this.toggleFullScreenMode();
      this.$refs.video.play().catch(() => {});
    }
    if (this.product.consume?.currentPosition) {
      this.$refs.video.currentTime = this.product.consume.currentPosition;
    }
  },
  beforeDestroy() {
    if (this.currentTime) {
      this.$emit('exit', { type: 'exit', currentPosition: this.currentTime, totalLength: this.totalTime });
    }
    document.removeEventListener('keydown', this.keyboardHandler);
    document.removeEventListener('mouseup', this.documentMouseUpHandler);
    document.removeEventListener('mousemove', this.documentMouseMoveHandler);
  },
};
</script>
<style lang="scss">
.videoPlayer-container {
  position: relative;
  width: 100%;
  // max-width: 1000px;
  display: flex;
  justify-content: center;
  margin-inline: auto;
  background-color: black;
}
.central-play-pause-btns {
  position: absolute;
  margin: auto;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.central-play-btn,
.central-pause-btn {
  width: 80px;
  height: 80px;
  background: #3338;
  padding: 40px;
  border-radius: 50%;
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0;
}
.central-play-btn {
  i {
    color: #ccce;
    font-size: 2.3rem;
    margin-left: 12px;
  }
}
.central-pause-btn {
  i {
    color: #ccce;
    font-size: 2.3rem;
  }
}

.animatePlayPause {
  // animation-iteration-count: 1;
  animation: playPause 0.5s ease-in-out;
}

@keyframes playPause {
  0% {
    opacity: 0.4;
    transform: scale(1);
  }
  30% {
    opacity: 1;
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
  }
}

.videoPlayer-container.theater,
.videoPlayer-container.full-screen {
  max-width: initial;
  width: 100%;
}

.videoPlayer-container.theater {
  max-height: 90vh;
}

.videoPlayer-container.full-screen {
  max-height: 100dvh;
}

.videoPlayer-container video {
  width: 100%;
}

.video-controls-container {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  z-index: 100;
  opacity: 0;
  transition: opacity 150ms ease-in-out;
}

.video-controls-container::before {
  content: '';
  position: absolute;
  bottom: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
  width: 100%;
  aspect-ratio: 6 / 1;
  z-index: -1;
  pointer-events: none;
}

.videoPlayer-container:hover .video-controls-container,
.videoPlayer-container:focus-within .video-controls-container,
.videoPlayer-container.paused .video-controls-container {
  opacity: 1;
}

.video-controls-container .controls {
  display: flex;
  gap: 0.5rem;
  padding: 0.25rem;
  align-items: center;
}

.video-controls-container .controls button {
  background: none;
  border: none;
  color: inherit;
  padding: 0;
  height: 30px;
  width: 30px;
  font-size: 1.1rem;
  cursor: pointer;
  opacity: 0.85;
  transition: opacity 150ms ease-in-out;
}

.video-controls-container .controls button:hover {
  opacity: 1;
}

.videoPlayer-container.theater .tall {
  display: none;
}

.videoPlayer-container:not(.theater) .wide {
  display: none;
}

.videoPlayer-container.full-screen .open {
  display: none;
}

.videoPlayer-container:not(.full-screen) .close {
  display: none;
}

.videoPlayer-container[data-volume-level='high'] .volume-high-icon {
  display: block;
}

.videoPlayer-container[data-volume-level='low'] .volume-low-icon {
  display: block;
}

.videoPlayer-container[data-volume-level='muted'] .volume-muted-icon {
  display: block;
}

.volume-container {
  display: flex;
  align-items: center;
}

.volume-slider {
  overflow: hidden;
  width: 0;
  transform-origin: left;
  transform: scaleX(0);
  transition: width 150ms ease-in-out, transform 150ms ease-in-out;
  accent-color: white;

  &::-webkit-slider-thumb {
    cursor: pointer;
  }
}

.volume-container:hover .volume-slider,
.volume-slider:focus-within {
  width: 100px;
  transform: scaleX(1);
}

.duration-container {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-grow: 1;
}

.videoPlayer-container.captions .captions-btn {
  border-bottom: 3px solid teal;
}

.video-controls-container .controls button.wide-btn {
  width: 50px;
}

.speed-select {
  cursor: pointer;
  background: transparent;
  color: white;
  border: none;
  max-width: 64px;
  option {
    background: black;
    color: white;
  }
}

.timeline-container {
  height: 7px;
  margin-inline: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.timeline {
  background-color: rgba(100, 100, 100, 0.5);
  height: 3px;
  width: 100%;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: calc(100% - var(--preview-position) * 100%);
  background-color: rgb(150, 150, 150);
  display: block;
}

.timeline::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: calc(100% - var(--progress-position) * 100%);
  background-color: teal;
}

.timeline .thumb-indicator {
  --scale: 0;
  position: absolute;
  transform: translateX(-50%) scale(var(--scale));
  height: 200%;
  top: -50%;
  left: calc(var(--progress-position) * 100%);
  background-color: teal;
  border-radius: 50%;
  transition: transform 150ms ease-in-out;
  aspect-ratio: 1 / 1;
}

.timeline .preview-img {
  position: absolute;
  height: 80px;
  aspect-ratio: 16 / 9;
  top: -1rem;
  transform: translate(-50%, -100%);
  left: calc(var(--preview-position) * 100%);
  border-radius: 0.25rem;
  border: 2px solid white;
  display: none;
}

.thumbnail-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: none;
}

.videoPlayer-container.scrubbing .thumbnail-img {
  display: block;
}

.videoPlayer-container.scrubbing .preview-img,
.timeline-container:hover .preview-img {
  display: block;
}

.videoPlayer-container.scrubbing .timeline::before,
.timeline-container:hover .timeline::before {
  display: block;
}

.videoPlayer-container.scrubbing .thumb-indicator,
.timeline-container:hover .thumb-indicator {
  --scale: 1;
}

.videoPlayer-container.scrubbing .timeline,
.timeline-container:hover .timeline {
  height: 100%;
}
</style>
